export default "__VITE_ASSET__CXrvVV7V__"